<script lang="ts">
    import { Modal } from "flowbite-svelte";
    import type { ComponentProps, Snippet } from "svelte";
    import { twMerge } from "tailwind-merge";
    import type { HTMLAttributes } from "svelte/elements";
    import type { Color } from "../types";

    interface Props extends HTMLAttributes<HTMLDialogElement> {
        children: () => any;
        class?: HTMLAttributes<any>["class"];
        open?: boolean;
        onclose?: (e: any) => void;
        lightText?: boolean;
        title?: string;
        color?: Color;
        footer?: Snippet;
    }

    let {
        children,
        class: clazz = "",
        lightText = true,
        open = $bindable(),
        onclose: onCloseFunc,
        title,
        footer,
        color = "default",
        ...others
    }: Props & ComponentProps<Modal>
        = $props();

    const colorClass: Record<Color, string> = {
        red: "frappe:bg-ctp-red bg-red-500",
        green: "frappe:bg-ctp-green bg-green-500",
        yellow: "frappe:bg-ctp-yellow bg-yellow-500",
        blue: "frappe:bg-ctp-blue bg-blue-500",
        pink: "frappe:bg-ctp-pink bg-pink-500",
        teal: "frappe:bg-ctp-teal bg-teal-500",
        rosewater: "frappe:bg-ctp-rosewater bg-rosewater-500",
        crust: "frappe:bg-ctp-crust bg-crust-500",
        lavender: "frappe:bg-ctp-lavender bg-lavender-500",
        default: "frappe:bg-ctp-base bg-gray-100 black:bg-black black:text-white",
    };

    const closeFunc = onCloseFunc != undefined ? onCloseFunc : () => {
    };

    function getColor() {
        if (colorClass[color] != undefined) return colorClass[color];

        return colorClass["default"];
    }

    const headerClass = "focus:ring-none frappe:[&>button:has(span.sr-only):hover]:bg-ctp-pink frappe:[&>button:has(span.sr-only):hover]:text-ctp-base" +
        " black:[&>button:has(span.sr-only):hover]:bg-white black:[&>button:has(span.sr-only):hover]:text-black";

    const textColor = !lightText ? "frappe:text-ctp-base frappe:divide-ctp-base" : "frappe:text-ctp-subtext0 frappe:divide-ctp-subtext0";

    const combinedClass = twMerge(headerClass, textColor, getColor(), clazz.toString());

    const classOnly = twMerge(combinedClass, "rounded-lg");
</script>

{#if footer === undefined}
    <Modal on:close={closeFunc} {title} bind:open={open}
           class={classOnly}
           classBody={combinedClass}
           classHeader={combinedClass}
           classFooter={combinedClass}
           {...others}>
        {@render children()}
    </Modal>
{:else}
    <Modal on:close={closeFunc} {title} bind:open={open}
           class={classOnly}
           classBody={combinedClass}
           classHeader={combinedClass}
           classFooter={combinedClass}
           {...others}>
        {@render children()}

        <svelte:fragment slot="footer">
            {@render footer()}
        </svelte:fragment>
    </Modal>

{/if}